var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _path0, _path1, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalkonSmsTextLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FSMS_Dark",
    "data-name": "FSMS Dark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4081.1 1125.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#161b21;}.cls-2,.cls-5{fill:#1450ff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{opacity:0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 435.75,
    x2: 293.11,
    y2: 435.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1163.51,
    y1: 567.83,
    x2: 1704.93,
    y2: 567.83,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1782.7,882.5V628h152.7v27.3H1813.6v86h110.3v27.4H1813.6V882.5Z",
    transform: "translate(-98.8 -202.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2001.7,882.5h-32.3L2062.8,628h31.9l93.4,254.5h-32.3l-76.1-214.3h-2Zm11.9-99.4h130.3v27.3H2013.6Z",
    transform: "translate(-98.8 -202.7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2262.9,882.5V628h30.8V855.2H2412v27.3Z",
    transform: "translate(-98.8 -202.7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2494.8,882.5V628h30.8V754.3h3L2642.9,628h40.3L2576.3,742.8l106.9,139.7h-37.3l-88.5-118.3L2525.6,800v82.5Z",
    transform: "translate(-98.8 -202.7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2960.8,755.2q0,40.3-14.5,69.6t-39.9,45.3c-16.9,10.6-36.3,15.9-58,15.9s-41-5.3-57.9-15.9-30.2-25.7-39.9-45.3-14.5-42.7-14.5-69.6,4.8-50,14.5-69.6,23-34.6,39.9-45.2,36.2-15.9,57.9-15.9,41.1,5.3,58,15.9,30.2,25.7,39.9,45.2S2960.8,728.4,2960.8,755.2Zm-29.8,0q0-33-11-55.8T2890.3,665a80.7,80.7,0,0,0-83.7,0q-18.7,11.7-29.7,34.4t-11,55.8q0,33.1,11,55.9t29.7,34.4a80.7,80.7,0,0,0,83.7,0q18.6-11.7,29.7-34.4T2931,755.2Z",
    transform: "translate(-98.8 -202.7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3249.3,628V882.5h-29.8L3080.8,682.7h-2.5V882.5h-30.8V628h29.8l139.2,200.3h2.5V628Z",
    transform: "translate(-98.8 -202.7)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3568.4,709.2c-1-10-5.2-17.8-12.8-23.4s-17.7-8.3-30.7-8.3c-8.7,0-16.2,1.2-22.2,3.7a30.9,30.9,0,0,0-13.9,10.1,23.9,23.9,0,0,0-4.8,14.6,21.5,21.5,0,0,0,3,12,27.8,27.8,0,0,0,8.7,8.7,63,63,0,0,0,13,6.4,114.1,114.1,0,0,0,15.6,4.5l22.9,5.5a166.3,166.3,0,0,1,30.6,9.9,97.3,97.3,0,0,1,24.1,15.3,65.1,65.1,0,0,1,15.8,21.4c3.8,8.2,5.7,17.6,5.8,28.2-.1,15.6-4,29.1-11.9,40.5s-19.1,20.2-33.8,26.4-32.4,9.4-53.1,9.4-38.4-3.1-53.6-9.4-27.1-15.7-35.6-28.1-12.9-27.7-13.3-46h52c.6,8.5,3.1,15.6,7.4,21.3a39.4,39.4,0,0,0,17.5,12.8,67.9,67.9,0,0,0,25,4.3c9.1,0,17-1.3,23.8-4s12-6.3,15.7-11a26,26,0,0,0,5.6-16.3,21.6,21.6,0,0,0-5-14.4c-3.4-3.9-8.3-7.2-14.7-10a150.9,150.9,0,0,0-23.6-7.4l-27.7-7c-21.4-5.2-38.4-13.4-50.8-24.5s-18.6-26-18.5-44.8c-.1-15.5,4-28.9,12.3-40.4s19.8-20.6,34.4-27,31.1-9.7,49.7-9.7,35.4,3.2,49.5,9.7,25.2,15.4,33,27,12,24.8,12.2,40Z",
    transform: "translate(-98.8 -202.7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3663,636h66.4l70.1,171h3l70.1-171H3939V890.5h-52.2V724.8h-2.2l-65.8,164.5h-35.6l-65.8-165.1h-2.2V890.5H3663Z",
    transform: "translate(-98.8 -202.7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4124.8,709.2c-1-10-5.3-17.8-12.8-23.4s-17.8-8.3-30.7-8.3c-8.8,0-16.2,1.2-22.3,3.7a31.1,31.1,0,0,0-13.8,10.1,23.9,23.9,0,0,0-4.8,14.6,20.6,20.6,0,0,0,2.9,12,28.1,28.1,0,0,0,8.8,8.7A59.7,59.7,0,0,0,4065,733a115.6,115.6,0,0,0,15.7,4.5l22.8,5.5a166.3,166.3,0,0,1,30.6,9.9,95.4,95.4,0,0,1,24.1,15.3,65.4,65.4,0,0,1,15.9,21.4,69.5,69.5,0,0,1,5.8,28.2c-.1,15.6-4.1,29.1-11.9,40.5s-19.1,20.2-33.8,26.4-32.4,9.4-53.2,9.4-38.4-3.1-53.6-9.4-27-15.7-35.5-28.1-13-27.7-13.4-46h52.1c.6,8.5,3,15.6,7.4,21.3a38.9,38.9,0,0,0,17.5,12.8,67,67,0,0,0,24.9,4.3c9.1,0,17.1-1.3,23.8-4s12-6.3,15.7-11a25.4,25.4,0,0,0,5.6-16.3c0-5.7-1.6-10.5-5-14.4s-8.2-7.2-14.7-10a149.4,149.4,0,0,0-23.5-7.4l-27.7-7c-21.5-5.2-38.4-13.4-50.9-24.5s-18.6-26-18.5-44.8c-.1-15.5,4.1-28.9,12.4-40.4s19.8-20.6,34.3-27,31.2-9.7,49.8-9.7,35.4,3.2,49.5,9.7,25.1,15.4,33,27,11.9,24.8,12.2,40Z",
    transform: "translate(-98.8 -202.7)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150.1,
    y: 687.5,
    width: 293.1,
    height: 109.92,
    rx: 55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 149.9,
    y: 78,
    width: 293.1,
    height: 109.92,
    rx: 55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 380.8,
    width: 293.1,
    height: 109.92,
    rx: 55
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1524.1,396.9c-140.2-37.2-226.3,32.6-360.6,60l236.2,236.2c17,17,27.6,37.1,31.5,56.3,1.5-4.9,3-9.4,4.4-13.5,95.9-270.2,269.3-184,269.3-184S1669.8,435.5,1524.1,396.9Z",
    transform: "translate(-98.8 -202.7)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M940.1,228.5l475.6,451.9a93.8,93.8,0,0,1,3.4,132.5L935.8,1321.5c-12.3,12.9-34,4.6-34.5-13.2l-5.5-216.8L488.2,704.1a93.7,93.7,0,0,1-3.4-132.5L807.6,231.9A93.7,93.7,0,0,1,940.1,228.5Zm104.7,638a64.4,64.4,0,1,0-2.3-91.1A64.4,64.4,0,0,0,1044.8,866.5ZM904.6,733.3a64.5,64.5,0,1,0-2.3-91.1A64.6,64.6,0,0,0,904.6,733.3ZM764.4,600.1a64.5,64.5,0,1,0-2.3-91.2A64.6,64.6,0,0,0,764.4,600.1Z",
    transform: "translate(-98.8 -202.7)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3214.6,
    y: 446.8,
    width: 94.4,
    height: 283
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonSmsTextLogo);
export default __webpack_public_path__ + "static/media/falkon-sms-text-logo.4d8fd58de6f57d1e9230263e821ef30d.svg";
export { ForwardRef as ReactComponent };